import {
  Button,
  Grid,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  useMediaQuery,
  CircularProgress,
  Backdrop
} from "@mui/material";
import React, { useState, useRef } from "react";
import { useEffect } from "react";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomTextField from "../CustomComponents/CustomTextField";
import { Box } from "@mui/system";
import axios from "axios";
import { BranchAction } from "../Store/Branch";
import { useDispatch } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const NachInward = () => {
  //Dispatch
  const dispatch = useDispatch();
  // Loading Branches
  const [branchArray, setBranchArray] = useState([]);
  const [branchValue, setBranchValue] = useState(null);
  const [branchTouch, setBranchTouch] = useState(false);
  const [branchValid, setBranchValid] = useState(false);
  const [branchHasError, setBranchHasError] = useState(false);
  const [uploadBtnDisable, setUploadBtnDisable] = useState(false);

  //Success Dialog Message Handler
  const [sucessDialogOpen, setSuccessDialogOpen] = useState(false);
  //Handle Sucess Dialog Message
  const [successDialogMessage, setSuccessDialogMessage] = useState("");
  const handlerSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState(
    "Loading Data Please Wait ....."
  );

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    const branchValues = GetBranchDetails();
    setBranchArray(branchValues);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  //shortcut key
  const downloadRef = useRef(null);
  const uploadRef = useRef(null);
  const dwnldRegRef = useRef(null);
  const okRef = useRef(null);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachInward",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    const refList = {
      downloadRef: downloadRef,
      uploadRef: uploadRef,
      dwnldRegRef:dwnldRegRef,
      okRef: okRef,
    };
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      handlerSuccessDialogClose();
    }
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.getShortCutValue({
          event: event,
          refs: refList,
          screen: "nachInward",
        })
      );
    }
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const handleDownload = () => {
    try {
      setLoading(true)
      setLoadingMsg("Downloading sample file...")
      axios
        .get("/nachInvert/downloadExcel", {
          method: "GET",
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Nach_upload.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setMessage("Nach Inward Sample Import File Downloaded Success.");
          setAlertType("success");
          openAlertHandler();
          setLoading(false)
        });
    } catch (error) {
      setLoading(false)
      setMessage("Nach Inward Sample Import File Downloaded Failed.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  };

  const handleRegDataDownload = () => {
    try {
      axios
        .get("nachInvert/downloadRegisteredRecords", {
          method: "GET",
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Nach_registered_data.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setMessage("Nach Registered Data File Downloaded Success.");
          setAlertType("success");
          openAlertHandler();
        });
    } catch (error) {
      setMessage("Nach Registered Data File Downloaded Failed.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  }

  const validateBranch = () => {
    if (!branchValid) {
      setBranchTouch(true);
      setBranchHasError(true);
      setBranchValid(false);
      // now reset the dialog close.
      let element = document.getElementById("fileUploadInput");
      element.disabled = true;
      setTimeout(function () {
        element.disabled = false;
      }, 1);
    } else {
      setBranchValid(branchValue !== undefined && branchValue !== "");
      setBranchTouch(false);
      setBranchHasError(branchTouch && !branchValid);
    }
  };

  const handleFileUpload = async (event) => {
    setUploadBtnDisable(true);
    const file = event.target.files[0];
    try {
      setLoading(true)
      setLoadingMsg("Processing data please wait...")
      event.preventDefault();
      const formData = new FormData();
      formData.append("file", file);
      formData.append("branch", "");
      formData.append("operationMode", "NACH");
      // now reset the file.
      let element = document.getElementById("fileUploadInput");
      element.value = null;
      const response = await axios.post(
        "/nachInvert/uploadNachInvertExcelUpload",
        formData,
        {
          method: "POST",
          responseType: "blob",
        }
      );
      if (response.status === 200) {
        setLoading(false)
        setSuccessDialogOpen(true);
        setSuccessDialogMessage("NACH Inward Process Completed Successfully.");
        setMessage("NACH Inward Process Completed Successfully.");
        setAlertType("success");
        //openAlertHandler();
        setUploadBtnDisable(false);
      }
      if (response.status === 206) {
        setLoading(false)
        setMessage("Error Data Exists in Imported File.");
        setAlertType("error");
        openAlertHandler();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Nach_Inward_ErrorData__` + new Date() + `.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setUploadBtnDisable(false);
      }
    } catch (error) {
      setLoading(false)
      setUploadBtnDisable(false);
      if (error.response.status === 400 || error.response.status === 500) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("branch", "");
        formData.append("operationMode", "NACH");
        const response = await axios.post(
          "/nachInvert/nachInwardErrorCheck",
          formData
        );
        if (response.status === 206) {
          setMessage(response.data);
          setAlertType("error");
        }
        openAlertHandler();
      }
    }
  };

  return (
    <React.Fragment>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{loadingMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Inward"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={0} columnSpacing={2}>
              {/* <Grid item xs={12} md={4}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Branch"
                  label="Branch"
                  autoCompleteValues={branchArray}
                  value={branchValue}
                  required={true}
                  onChange={(event, newValue) => {
                    setBranchValue(newValue);
                    setBranchTouch(newValue ? false : true);
                    setBranchValid(
                      newValue !== undefined &&
                        newValue !== "" &&
                        newValue !== null
                    );
                    setBranchHasError(
                      (newValue ? false : true) &&
                        !(
                          newValue !== undefined &&
                          newValue !== "" &&
                          newValue !== null
                        )
                    );
                    dispatch(BranchAction.updateInitialLoad(false));
                    if (newValue) {
                      dispatch(
                        BranchAction.updateHeaderBranchDetails(newValue.label)
                      );
                    }
                  }}
                />
                {branchHasError && (
                  <p className="error">Please Select Branch</p>
                )}
              </Grid> */}
              <Grid item xs={12} md={4}>
                <CustomTextField
                  type="text"
                  label="Mode of Operation"
                  variant="standard"
                  value="NACH"
                  disabled="true"
                />
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+J" placement="top">
                <Button
                  variant="contained"
                  component="label"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={() => {
                    // if (!branchValid) {
                    //   setBranchTouch(true);
                    //   setBranchHasError(true);
                    //   setBranchValid(false);
                    // } else {
                    //   setBranchValid(
                    //     branchValue !== undefined &&
                    //       branchValue !== "" &&
                    //       branchValue !== null
                    //   );
                    //   setBranchTouch(false);
                    //   setBranchHasError(branchTouch && !branchValid);
                    //   handleDownload();
                    // }
                    handleDownload();
                  }}
                  ref={downloadRef}
                >
                  Download
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+U" placement="top">
                <Button
                  variant="contained"
                  component="label"
                  disabled={uploadBtnDisable}
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  // onClick={validateBranch}
                  ref={uploadRef}
                >
                  Upload
                  <input
                    hidden
                    id="fileUploadInput"
                    accept=".xlsx"
                    type="file"
                    sx={{ height: "2rem" }}
                    onChange={handleFileUpload}
                  />
                </Button>
              </Tooltip>
              <Tooltip title="" placement="top">
                <Button
                  variant="contained"
                  component="label"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={() => {
                    handleRegDataDownload();
                  }}
                  ref={downloadRef}
                >
                  Download Registered Data
                </Button>
              </Tooltip>
            </Box>
            <Dialog
              open={sucessDialogOpen}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{"Success"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {successDialogMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Tooltip title="Ctrl+K" placement="top">
                  <Button onClick={handlerSuccessDialogClose} ref={okRef}>
                    OK
                  </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
            <Snackbar
              open={alert}
              autoHideDuration={3000}
              anchorOrigin={{ vertical, horizontal }}
              onClose={closeAlertHandler}
            >
              <Alert
                onClose={closeAlertHandler}
                severity={alertType}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
          </Box>
        </AccordianContainer>
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
};

export default NachInward;
